import api from '../api'

export default {
    namespaced: true,
    state: {
        projectId: null,
        projectDetails: null,
        projectMedia: [],
        projectEvents: [],
        projectPeriodicTasks: [],
        tmimata: [],
    },
    actions: {
        getProjectEvents({commit, state}) {
            if (state.projectEvents.length) {
                return Promise.resolve(state.projectEvents)
            } else {
                commit('showLoading', null, {root: true});
                return api.events.getEventDetails({
                    Project_ID: state.projectId,
                })
                    .then(resp => {
                        commit('hideLoading', null, {root: true});
                        let sortedEvents = resp.sort((a, b) => new Date(b.DateEventInsert) - new Date(a.DateEventInsert));
                        commit('setProjectEvents', sortedEvents);
                        return Promise.resolve(sortedEvents);
                    })
            }

        },
        getProjectPeriodicTasks({commit, state}) {
            commit('showLoading', null, {root: true})
            if (state.projectPeriodicTasks.length) {
                return state.projectPeriodicTasks
            }
            return api.issues.getIssues({OnlyPeriodic: true, Project_ID: state.projectId}).then(issues => {
                commit('hideLoading', null, {root: true});
                commit('setProjectPeriodicTask', issues)
                return Promise.resolve(issues)
            }).finally(() => {
                commit('hideLoading', null, {root: true});
            })
        }
        ,
        getProjectDetails({commit, state}, resetProject) {
            commit('showLoading', null, {root: true});
            if (state.projectDetails && !resetProject) {
                return Promise.resolve(state.projectDetails)
            } else {
                return api.projects.getProjectDetails(state.projectId).then(
                    resp => {
                        commit('setProjectDetails', resp);
                        commit('hideLoading', null, {root: true});
                        return Promise.resolve(resp)
                    }
                )
            }

        },
        deleteProjectPicture({commit}, fileName) {
            api.projects.deleteProjectPicture(fileName)
                .then(() => {
                    commit('removeProjectMedia', fileName)
                })
        },
        getProjectPictures({commit, state}) {
            commit('showLoading', null, {root: true});
            return api.projects.getProjectPictures(state.projectId)
                .then(resp => {
                    commit('setProjectMedia', resp);
                    commit('hideLoading', null, {root: true});
                    return Promise.resolve(resp);
                })
        }
    },
    mutations: {
        resetProject(state) {
            state.projectEvents = [];
            state.projectDetails = null;
            state.projectMedia = [];
            state.projectPeriodicTasks = []
            state.projectId = null;
            state.tmimata = null;
        },
        removeProjectMedia(state, filename) {
            state.projectMedia = state.projectMedia.filter(p => p.FileName !== filename)
        },
        setProjectEvents(state, projectEvents) {
            state.projectEvents = projectEvents;
        },
        setProjectId(state, id) {
            state.projectMedia = [];
            state.projectDetails = null;
            state.projectId = id;
        },
        setProjectPeriodicTask(state, periodicTasks) {
            state.projectPeriodicTasks = periodicTasks
        },
        setProjectMedia(state, {Pictures, Tmimata}) {
            state.projectMedia = Pictures;
            state.tmimata = Tmimata;
        },
        setProjectDetails(state, projectDetails) {
            state.projectDetails = projectDetails;
        }
    },
    getters: {
        projectPeriodicTasks: s => s.projectPeriodicTasks.sort((a, b) => {
            return new Date(b.getLastAction().DateInsert) - new Date(a.getLastAction().DateInsert)
        }),
        projectEvents: s => s.projectEvents,
        projectDetails: s => s.projectDetails,
        projectId: s => s.projectId,
        projectMedia: s => s.projectMedia,
    }

}
